import * as React from 'react';
import Div from "@jumbo/shared/Div";
import ContentWrapper from 'app/components/ContentWrapper/ContentWrapper';
import { Typography } from "@mui/material";
import MobileFooter from 'app/components/MobileFooter/MobileFooter';
import MobileHeader from 'app/components/MobileHeader/MobileHeader';
import InputIcon from 'app/components/InputIcon/InputIcon';
import DialogActions from '@mui/material/DialogActions';
import { useLocation, useNavigate } from "react-router-dom";
import Swal from 'sweetalert2';
import { requestApi } from 'app/utils/RestApi';
import ButtonStyled from 'app/components/ButtonStyled/ButtonStyled';
import { setupParamsReferrer } from 'app/services/setupWebview';
import { REFERRER } from 'app/utils/constants/endPoint';
import { isMobile } from 'react-device-detect';
import { Field, Form, Formik } from 'formik';
import editReferrerSchemaWaiting from './editReferrerSchemaWaiting';

const WebviewEditReferrer = () => {
	const navigate = useNavigate();

	const location = useLocation()

	const [fieldTouched, setFieldTouched] = React.useState({
		bankName: false,
		name: false,
		email: false,
		accountNumber: false,
		accountName: false,
		npwpStatus: false,
		npwpNumber: false,
	});

	let referrer = null

	if (location?.state) {
		referrer = location?.state?.referrer
	}

	const navigateBack = () => {
		navigate(-1);
	};

	const [formData, setFormData] = React.useState({
		name: '',
		email: '',
		agentCode: ''
	})


	React.useEffect(() => {
		// if (!isMobile) {
		// 	Swal.fire({
		// 		icon: 'warning',
		// 		title: 'Forbidden!',
		// 		text: 'Halaman ini tidak dapat diakses melalui browser',
		// 		allowOutsideClick: '',
		// 		showConfirmButton: false
		// 	});
		// } else {
		// 	initData();
		// }
			initData();
	}, []);

	const initData = async () => {
		// let agentCodeTmp = ''
		// setupParamsReferrer(location.search, ({ agentCode }) => {
		// 	console.log('setupParamsReferrer agentCode : ', agentCode);
		// 	agentCodeTmp = agentCode;
		// }, false, navigateBack)

		// console.log('referrer : ',referrer);


		if (!referrer) {
			Swal.fire({
				icon: 'warning',
				title: 'Forbidden!',
				text: 'Referrer data not found!',
				allowOutsideClick: '',
				showConfirmButton: false
			});
		}

		setFormData({
			...referrer,
			agentCode: referrer.agent.agentCode,
			npwpStatus: referrer.npwpStatus ? '01' : '00'
		});

	}

	const preparePayload = (data) => {
		let request = {
			name: data.name,
			email: data.email,
		}

		request.agentCode = formData.agentCode.trim();
		if (request.agentCode.includes('%20')) {
			request.agentCode = request.agentCode.replaceAll("%20", "");
		}

		if (referrer?.id) {
			request.id = referrer?.id
		}

		return request;
	}

	const sendData = async (values) => {
		const payload = preparePayload(values);

		Swal.showLoading()
		await requestApi(REFERRER.EDIT["02"], {
			data: payload
		}).then(({ data }) => {
			Swal.close();
			if (data?.status === 'success') {
				localStorage.setItem('tab', 0);
				navigateBack();
				localStorage.removeItem("refferer_memory")
				Swal.fire({
					icon: 'success',
					text: 'Data berhasil disimpan'
				});
			}
		}).catch(err => {
			Swal.close();
			if (err?.data) {
				var arrayError = [];
				for (let [key, value] of Object.entries(err.data)) {
					arrayError.push(value)
				}
				var errorJoin = arrayError.join('<br>');

				Swal.fire({
					icon: 'error',
					text: errorJoin
				});
			} else if (err?.message) {
				Swal.fire({
					icon: 'error',
					text: err.message
				});
			} else {
				Swal.fire({
					icon: 'error',
					text: 'Bad request'
				});
			}
		})
	}



	return (
		<Div className='page-wrapper-mobile'>

			{/* 🔥 HEADER */}
			<MobileHeader
				backIcon
				headerTx={"Add Referrer"}
				backOnClick={navigateBack}
			/>
			<Formik
				initialValues={formData}
				enableReinitialize={true}
				validationSchema={editReferrerSchemaWaiting}
				onSubmit={(values) => {
					sendData(values)
				}}
			>
				{({ errors, values, handleSubmit, setValues }) => {

					function formikSetValue(field, value) {
						setValues({
							...values,
							[field]: value
						})
					}
					return (
						formData &&
						<Form style={{ width: '100%' }}>
							{/* 🔥 CONTENT */}
							<ContentWrapper isMobile>


								{/* 🔥 typography */}
								<Typography fontSize={16} fontWeight={600}>Silakan Lengkapi Data Diri Anda</Typography>

								{/* 🔥 input with icon left/right */}
								<Div sx={{ mt: 2 }}>
									<Div sx={{ mb: 2 }}>
										<Field name="name">
											{({
												field,
												value,
												form: { handleChange },
												meta,
											}) => (
												<>
													<InputIcon
														required
														name="name"
														value={meta.value}
														onChange={handleChange}
														inputLabel={"Nama Lengkap (sesuai KTP)"}
														placeholder={"Nama Lengkap"}
														onBlur={() => {
															if (!fieldTouched.name) {
																setFieldTouched((prevState) => ({ ...prevState, ['name']: true }))
															}
														}}
													/>
													{(fieldTouched.name && meta.error) && <span style={{ color: 'red' }}>{meta.error}</span>}
												</>
											)}
										</Field>
									</Div>
									<Field name="email">
										{({
											field,
											value,
											form: { handleChange },
											meta,
										}) => (
											<>
												<Div sx={{ mb: 2 }}>
													<InputIcon
														required
														value={meta.value}
														onBlur={() => {
															if (!fieldTouched.email) {
																setFieldTouched((prevState) => ({ ...prevState, ['email']: true }))
															}
														}}
														name="email"
														onChange={handleChange}
														inputLabel={"Alamat Email"}
														placeholder={"Alamat Email"}

													/>
													{(fieldTouched.email && meta.error) && <span style={{ color: 'red' }}>{meta.error}</span>}
												</Div>
											</>)}
									</Field>
								</Div>

							</ContentWrapper>

							{/* 🔥 FOOTER */}
							<MobileFooter>
								<DialogActions className='custom-btn'>
									<ButtonStyled
										disabled={Object.values(errors).length > 0}
										btnText={"Kirim"}
										preset={"primary"}
										onClick={handleSubmit}
									/>

								</DialogActions>

							</MobileFooter>
						</Form>
					)
				}}

			</Formik>
		</Div>

	);
};

export default WebviewEditReferrer;